export default {"src":"/_next/static/media/carret-down.944ef3b2.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};